module.exports = __webpack_public_path__ + "img/kjsy_gallery1.776d0dbb.jpg";